import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarHairStyle1 } from './Style1'
import { Style as AvatarHairStyle10 } from './Style10'
import { Style as AvatarHairStyle11 } from './Style11'
import { Style as AvatarHairStyle2 } from './Style2'
import { Style as AvatarHairStyle3 } from './Style3'
import { Style as AvatarHairStyle4 } from './Style4'
import { Style as AvatarHairStyle5 } from './Style5'
import { Style as AvatarHairStyle6 } from './Style6'
import { Style as AvatarHairStyle7 } from './Style7'
import { Style as AvatarHairStyle8 } from './Style8'
import { Style as AvatarHairStyle9 } from './Style9'

export const NAME = 'hair'
export const STYLES = {
  style9: AvatarHairStyle9,
  style2: AvatarHairStyle2,
  style10: AvatarHairStyle10,
  style5: AvatarHairStyle5,
  style1: AvatarHairStyle1,
  style4: AvatarHairStyle4,
  style3: AvatarHairStyle3,
  style6: AvatarHairStyle6,
  style7: AvatarHairStyle7,
  style8: AvatarHairStyle8
}
export const STYLES_BACK = {
  style1: AvatarHairStyle1.Back,
  style3: AvatarHairStyle3.Back,
  style4: AvatarHairStyle4.Back,
  style5: AvatarHairStyle5.Back,
  style6: AvatarHairStyle6.Back,
  style7: AvatarHairStyle7.Back,
  style8: AvatarHairStyle8.Back,
  style9: AvatarHairStyle9.Back,
  style10: AvatarHairStyle10.Back,
  style11: AvatarHairStyle11.Back
}
export const INLINE_STYLE = {
  width: '175%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-3.5%)'
}
export const AvatarHair = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      name={NAME}
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}

const AvatarHairBack = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      STYLES={STYLES_BACK}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}

AvatarHair.Back = AvatarHairBack
